import DeleteUserModal from './ChangePasswordModal';
export default DeleteUserModal;
